<style scoped>
  .panel{background-color: white;box-shadow:0px 1px 8px #b5b5b5;border-radius:5px;}
  .progress{padding-top:40px;padding-bottom:40px;border-bottom:1px solid #d7dde4}
</style>
<template>
  <div class="panel">
    <div class="progress">
      <Steps :current="progress" style="margin:auto;width:785px;">
        <Step title="基本信息" content="填写基本信息索引利冲报告"></Step>
        <Step title="利冲报告" content="判定是否与已存在案件冲突"></Step>
        <Step title="完善信息" content="完善详细信息签署电子合同"></Step>
      </Steps>
    </div>
    <router-view style="padding:40px 100px"></router-view>
  </div>
</template>

<script>
  //说明:adviser 顾问项目 special 专项项目 litigation 诉讼项目
  export default {
    name: "create",//新建项目母版
    data:function () {
      return {
        progress:0,
      }
    },
    watch:{
      '$route.name':{
        handler(val){
          if(val=='adviserStep1'||val=='specialStep1'||val=='litigationStep1'){
            this.progress=0
          }
          if(val=='adviserStep2'||val=='specialStep2'||val=='litigationStep2'){
            this.progress=1
          }
          if(val=='adviserStep3'||val=='specialStep3'||val=='litigationStep3'){
            this.progress=2
          }
        },
        immediate:true,
      }
    },
  }
</script>